import type { SheetRow } from '../schemas/sheets';

/** Значения HTTP-строки — JSON; порядок ключей объекта не меняет содержимое. */
function sameJson(left: unknown, right: unknown): boolean {
  if (Object.is(left, right)) return true;
  if (!left || !right || typeof left !== 'object' || typeof right !== 'object') return false;
  if (Array.isArray(left) || Array.isArray(right)) {
    return Array.isArray(left) && Array.isArray(right) && left.length === right.length
      && left.every((value, index) => sameJson(value, right[index]));
  }
  const a = left as Record<string, unknown>;
  const b = right as Record<string, unknown>;
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length
    && keys.every(key => Object.prototype.hasOwnProperty.call(b, key) && sameJson(a[key], b[key]));
}

export function sameSheetRow(left: SheetRow, right: SheetRow): boolean {
  return sameJson(left, right);
}

/** Неизменившиеся строки сохраняют DOM и кеш высоты, но состав и порядок задаёт сервер. */
export function reconcileSheetRows(current: SheetRow[], incoming: SheetRow[]): SheetRow[] {
  return reconcileRows(current, incoming);
}

/** Снимок с сервера сохраняет ссылки неизменившихся строк и самого массива. */
export function reconcileRows<Row extends { id: string }>(current: Row[], incoming: Row[]): Row[] {
  const byId = new Map(current.map(row => [row.id, row]));
  const next = incoming.map(row => {
    const previous = byId.get(row.id);
    return previous && sameJson(previous, row) ? previous : row;
  });
  return next.length === current.length && next.every((row, index) => row === current[index]) ? current : next;
}
